/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sales_Order_Sync_Not_RetryableInputs */

const en_error_sales_order_sync_not_retryable = /** @type {(inputs: Error_Sales_Order_Sync_Not_RetryableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This order cannot be sent again now: Business Central already has it, or its last state is still on its way.`)
};

/**
* | output |
* | --- |
* | "This order cannot be sent again now: Business Central already has it, or its last state is still on its way." |
*
* @param {Error_Sales_Order_Sync_Not_RetryableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_sales_order_sync_not_retryable = /** @type {((inputs?: Error_Sales_Order_Sync_Not_RetryableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sales_Order_Sync_Not_RetryableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_sales_order_sync_not_retryable(inputs)
});